export enum SystemType {
    prepayTicket = 1,
    prepayCashless,
    pospayOrderPad = 4,
}
